import { ZepIcon_default } from './chunk-SGEFWXJL.mjs';
import { jsx } from 'react/jsx-runtime';

var CheckBoldIcon = ZepIcon_default((props) => /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M18.691 4.837a1.75 1.75 0 0 1 2.617 2.325l-10.667 12a1.751 1.751 0 0 1-2.617 0l-5.333-6a1.751 1.751 0 0 1 2.616-2.325l4.025 4.527 9.36-10.527Z",
    fill: props.fill || "currentColor"
  }
) }));

export { CheckBoldIcon };
